import styled from 'styled-components';
import { Colors, mediaQueries } from '@fourthwall/components';
export const CropperContainer = styled.div `
  position: relative;
  height: 408px;
  border: 1px solid ${Colors.GS500};
`;
export const Footer = styled.div `
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;

  ${mediaQueries.tablet} {
    flex-direction: row;
    gap: 16px;
    align-items: end;
    margin-top: 16px;
  }
`;
export const ButtonContainer = styled.div `
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
  width: 100%;

  ${mediaQueries.tablet} {
    flex-direction: row;
    gap: 16px;
    width: auto;
  }
`;
export const CheckboxContainer = styled.div `
  display: flex;
  flex-direction: column;

  ${mediaQueries.tablet} {
    min-height: 48px;
    justify-content: center;
  }

  & > * + * {
    margin-top: 12px;
  }
`;
